export enum HttpErrorResponseEnum {
  USER_INACTIVE = 'USER_INACTIVE',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  USER_ALREADY_EXIST = 'USER_ALREADY_EXIST',
  USER_NOT_CONFIRMED = 'USER_NOT_CONFIRMED',
  USER_DEACTIVATED = 'USER_DEACTIVATED',
  MEMBER_UNAVAILABLE = 'MEMBER_UNAVAILABLE',
  CANNOT_PROCEED_PAYMENT = 'CANNOT_PROCEED_PAYMENT',
  STRIPE_RATE_LIMIT = 'STRIPE_RATE_LIMIT',
  STRIPE_INACTIVE_CUSTOMER = 'STRIPE_INACTIVE_CUSTOMER',
  SOCIAL_MEDIA_EMAIL_NOT_FOUND = 'SOCIAL_MEDIA_EMAIL_NOT_FOUND',
  LAB_TEST_CODE_EXISTS = 'LAB_TEST_CODE_EXISTS',
}
